import { render, staticRenderFns } from "./backnav.vue?vue&type=template&id=6d98e7b2&scoped=true&"
import script from "./backnav.vue?vue&type=script&lang=js&"
export * from "./backnav.vue?vue&type=script&lang=js&"
import style0 from "./backnav.vue?vue&type=style&index=0&id=6d98e7b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d98e7b2",
  null
  
)

export default component.exports